
import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';
import './ServicesSection.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getServicesData } from '../data/servicesData';

const ServicesSection = () => {
  const { t } = useTranslation();
  const services = useMemo(() => getServicesData(t), [t]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <section className="services-section section-padding" id="services">
      <div className="services-container">
        <header className="services-header fade-up">
          <span className="services-label">{t('services_section_header_label')}</span>
          <h2>{t('services_section_header_title')}</h2>
        </header>

        <Slider {...sliderSettings} className="services-slider">
          {services.map((service, index) => (
            <div key={service.id} className={`service-slide fade-up stagger-${index + 1}`}>
              <article className="service-card">
                <Link to={`/services/${service.slug}`} className="service-image" aria-label={service.title}>
                  <img src={service.image} alt={service.title} loading="lazy" />
                </Link>
                <div className="service-body">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to={`/services/${service.slug}`} className="service-link">
                    {t('service_card_view_details')} <ArrowUpRight size={14} />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ServicesSection;
